/** @format */

import { makeObservable, observable, action } from "mobx";
import { createMobXContext, AsyncTools } from "@hilma/tools";
import Axios from "axios";
import colors from "../styles/colors";

class Data {
  range = null;
  viewOn = { value: "ever", label: "הכל" };
  cakeData = { all: null, done: null };
  tableListData = null;
  tableListDataFull = null;
  hearDonutData1 = null;
  hearDonutData2 = null;
  langLevel1 = null;
  langLevel2 = null;
  mathLevel1 = null;
  mathLevel2 = null;
  mathLevel3 = null;
  allTimeBoardgame = null;
  topTimeBoardgame = null;
  avgChildren = null;
  avgGamesADay = null;
  avgGamesAWeek = null;
  avgGamesAMonth = null;
  failedAttempts = null;
  replayInstruction = null;
  hearAnswers = null;
  failedAttemptsToChild = null;
  replayInstructionToChild = null;
  hearAnswersToChild = null;
  studentsName = null;
  gameTimeByParticipants = null;
  gameTimeByParticipantsByBoard = null;
  gameTimeByBoard = null;
  gameNames = null;
  constructor() {
    makeObservable(this, {
      range: observable,
      viewOn: observable,
      cakeData: observable,
      tableListData: observable,
      tableListDataFull: observable,
      hearDonutData1: observable,
      hearDonutData2: observable,
      langLevel1: observable,
      langLevel2: observable,
      mathLevel1: observable,
      mathLevel2: observable,
      mathLevel3: observable,
      allTimeBoardgame: observable,
      topTimeBoardgame: observable,
      avgChildren: observable,
      avgGamesADay: observable,
      avgGamesAWeek: observable,
      avgGamesAMonth: observable,
      failedAttempts: observable,
      replayInstruction: observable,
      hearAnswers: observable,
      failedAttemptsToChild: observable,
      replayInstructionToChild: observable,
      hearAnswersToChild: observable,
      studentsName: observable,
      gameTimeByParticipants: observable,
      gameTimeByParticipantsByBoard: observable,
      gameTimeByBoard: observable,
      gameNames: observable,
      getAllData: action,
      getDataForGameCake: action,
      getDataForListTable: action,
      getDataForHearDonut: action,
      getDataForDistributionLang: action,
      getDataForDistributionMath: action,
      setTableListData: action,
      setTableListDataFull: action,
      // getTimeBoardgames: action,
      getAllTimeBoardgame: action,
      setAllTimeBoardGame: action,
      setTopTimeBoardgame: action,
      setHearDonut1: action,
      setHearDonut2: action,
      setMathLevel1: action,
      setMathLevel2: action,
      setMathLevel3: action,
      setLangLevel1: action,
      setLangLevel2: action,
      setCakeData: action,
      getAvgChildren: action,
      getAvgGamesADay: action,
      getAvgGamesAWeek: action,
      setAvgChildren: action,
      setAvgGamesADay: action,
      setAvgGamesAWeek: action,
      getAvgGamesAMonth: action,
      setAvgGamesAMonth: action,
      setReplayInstruction: action,
      getStudentsName: action,
      getGameTimeByParticipants: action,
      setGameTimeByParticipants: action,
      getGameTimeByParticipantsByBoard: action,
      setGameTimeByParticipantsByBoard: action,
      getGameTimeByBoard: action,
      setGameTimeByBoard: action,
      getGameNames: action,
      setGameNames: action,
      getFailedAttemptsToChild: action,
      setFailedAttemptsToChild: action,
      setFailedAttempts: action,
      getFailedAttempts: action,
      getReplayInstructionToChild: action,
      setReplayInstructionToChild: action,
      getHearAnswersToChild: action,
      setHearAnswersToChild: action,
      setRange: action,
      setViewOn: action,
      getHearAnswers: action,
      setHearAnswers: action,
    });
  }

  getAllData = async (range, isChild, chosenBoard) => {
    (!this.cakeData.all || !this.cakeData.done || range) &&
      this.getDataForGameCake(range === "all" ? null : range);
    (!this.tableListData || range) &&
      this.getDataForListTable(6, null, range === "all" ? null : range);
    (!this.hearDonutData2 || !this.hearDonutData1 || range) &&
      this.getDataForHearDonut(range === "all" ? null : range);
    (!this.langLevel2 || !this.langLevel1) && this.getDataForDistributionLang();
    (!this.mathLevel1 || !this.mathLevel2 || !this.mathLevel3) &&
      this.getDataForDistributionMath();

    // TODO lipaz: גישה אחת לשרת
    (!this.avgChildren || range) &&
      this.getAvgChildren(range === "all" ? null : range);
    (!this.avgGamesADay || range) &&
      this.getAvgGamesADay(range === "all" ? null : range);
    (!this.avgGamesAWeek || range) &&
      this.getAvgGamesAWeek(range === "all" ? null : range);
    (!this.avgGamesAMonth || range) &&
      this.getAvgGamesAMonth(range === "all" ? null : range);

    // TODO lipaz: גישה אחת לשרת
    !isChild
      ? (!this.failedAttempts || range) &&
        this.getFailedAttempts(range === "all" ? null : range)
      : (!this.failedAttemptsToChild || range) &&
        this.getFailedAttemptsToChild(range === "all" ? null : range, isChild);
    !isChild
      ? (!this.replayInstruction || range) &&
        this.getReplayInstruction(range === "all" ? null : range)
      : (!this.replayInstructionToChild || range) &&
        this.getReplayInstructionToChild(
          range === "all" ? null : range,
          isChild
        );
    !isChild
      ? (!this.hearAnswers || range) &&
        this.getHearAnswers(range === "all" ? null : range)
      : (!this.hearAnswersToChild || range) &&
        this.getHearAnswersToChild(range === "all" ? null : range, isChild);

    // TODO: קורס כשמשנים תאריכים
    (!this.allTimeBoardgame || range) &&
      this.getAllTimeBoardgame(4, null, range === "all" ? null : range);

    !this.studentsName &&
      (await this.getStudentsName("10edb727-95cd-4c85-b708-e1bf45a978b8")); //!noy: i send the id of shakva kindergarten hard-coded

    // TODO: קורס כשמשנים תאריכים
    chosenBoard === "ever"
      ? (!this.gameTimeByParticipants || range) &&
        this.getGameTimeByParticipants(range === "all" ? null : range)
      : (!this.gameTimeByParticipantsByBoard || range) &&
        this.getGameTimeByParticipantsByBoard(
          range === "all" ? null : range,
          chosenBoard
        );
    // (!this.gameTimeByBoard || range) && this.getGameTimeByBoard(range === "all" ? null : rangeisChild);
    !this.gameNames &&
      (await this.getGameNames("10edb727-95cd-4c85-b708-e1bf45a978b8")); //!noy: i send the id of shakva kindergarten hard-coded
  };
  setGameNames = (v) => {
    this.gameNames = v;
  };
  getGameNames = async (kinderId) => {
    const [gameNamesErr, gameNamesRes] = await AsyncTools.to(
      Axios.get(`/api/game/getAllGameNames`, {
        params: { kindergartenId: kinderId },
      })
    );
    if (gameNamesErr) {
      console.log("gameNamesErr: ", gameNamesErr);
      return;
    }
    const allGameNames = gameNamesRes.data.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    this.setGameNames(allGameNames);
  };

  setGameTimeByBoard = (v) => {
    this.gameTimeByBoard = v;
  };
  getGameTimeByBoard = async (range, boardName) => {
    const [gameTimeByBoardErr, gameTimeByBoardRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getGameTimeByBoard`, {
        params: range
          ? { start: range.start, end: range.end, name: boardName }
          : { name: boardName },
      })
    );
    if (gameTimeByBoardErr) {
      console.log("get game time by board Error: ", gameTimeByBoardErr);
      return;
    }

    // let list = gameTimeByBoardRes.data.map(item => {
    //     return {
    //         value: item.name,
    //         label: item.name,
    //     }
    // })
    // console.log("gameTimeByBoardRes: ", gameTimeByBoardRes);
    // this.setGameTimeByBoard(list)
    // console.log(" this.setGameTimeByBoard: ", this.setGameTimeByBoard);
  };
  setRange = (r) => {
    this.range = r;
  };
  setViewOn = (v) => {
    this.viewOn = v;
  };
  setGameTimeByParticipants = (v) => {
    this.gameTimeByParticipants = v;
  };

  getGameTimeByParticipants = async (range) => {
    const [gameTimeByParticipantsErr, gameTimeByParticipantsRes] =
      await AsyncTools.to(
        Axios.get(`/api/fact/getGameTimeByParticipants`, {
          params: range ? { start: range.start, end: range.end } : null,
        })
      );
    if (gameTimeByParticipantsErr) {
      // console.log("gameTimeByParticipantsErr: ", gameTimeByParticipantsErr);
      return;
    }
    let dataForGraph = [];
    for (let i = 0; i < gameTimeByParticipantsRes.data.length; i++) {
      dataForGraph.push({
        participants:
          Number(gameTimeByParticipantsRes.data[i].num_students) +
          "\n" +
          "\nמשתתפים" +
          "\n",
        time: Number(gameTimeByParticipantsRes.data[i].seconds_game),
      });
    }
    this.setGameTimeByParticipants(dataForGraph);
  };

  setGameTimeByParticipantsByBoard = (v) => {
    this.gameTimeByParticipantsByBoard = v;
  };

  getGameTimeByParticipantsByBoard = async (range, chosenBoard) => {
    const [gameTimeByParticipantsByBoardErr, gameTimeByParticipantsByBoardRes] =
      await AsyncTools.to(
        Axios.get(`/api/fact/getGameTimeByParticipantsByBoard`, {
          params: range
            ? { start: range.start, end: range.end, name: chosenBoard }
            : { name: chosenBoard },
        })
      );
    if (gameTimeByParticipantsByBoardErr) {
      // console.log(
      //   "gameTimeByParticipantsByBoardErr: ",
      //   gameTimeByParticipantsByBoardErr
      // );
      return;
    }
    let dataForGraph = [];
    for (let i = 0; i < gameTimeByParticipantsByBoardRes.data.length; i++) {
      dataForGraph.push({
        participants:
          Number(gameTimeByParticipantsByBoardRes.data[i].num_students) +
          "\n" +
          "\nמשתתפים" +
          "\n",
        time: Number(gameTimeByParticipantsByBoardRes.data[i].seconds_game),
      });
    }

    this.setGameTimeByParticipantsByBoard(dataForGraph);
  };
  setStudentsName = (v) => {
    this.studentsName = v;
  };
  getStudentsName = async (kinderId) => {
    const [studentsNameErr, studentsNameRes] = await AsyncTools.to(
      Axios.get(`/api/student/getStudents`, {
        params: { kindergartenId: kinderId },
      })
    );
    if (studentsNameErr) {
      console.log("studentsNameErr: ", studentsNameErr);
      return;
    }
    const allStudents = studentsNameRes.data.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    this.setStudentsName(allStudents);
  };

  setAvgChildren = (v) => {
    this.avgChildren = v;
  };
  getAvgChildren = async (range) => {
    const [avgChiError, avgChiRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getAvgChildren`, {
        params: range ? { start: range.start, end: range.end } : null,
      })
    );
    if (avgChiError) {
      console.log("get average children Error: ", avgChiError);
      return;
    }
    this.setAvgChildren(Math.round(avgChiRes.data[0]["avg(num_students)"]));
  };

  setAvgChildren = (v) => {
    this.avgChildren = v;
  };
  getAvgChildren = async (range) => {
    const [avgChiError, avgChiRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getAvgChildren`, {
        params: range ? { start: range.start, end: range.end } : null,
      })
    );
    if (avgChiError) {
      console.log("get average children Error: ", avgChiError);
      return;
    }
    this.setAvgChildren(Math.round(avgChiRes.data[0]["avg(num_students)"]));
  };

  setAvgGamesADay = (v) => {
    this.avgGamesADay = v;
  };
  getAvgGamesADay = async (range) => {
    const [avgGameADayErr, avgGamesADayRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getAvgGamesADay`, {
        params: range ? { start: range.start, end: range.end } : null,
      })
    );
    if (avgGameADayErr) {
      console.log("get average games a day Error: ", avgGameADayErr);
      return;
    }
    this.setAvgGamesADay(Math.round(avgGamesADayRes.data[0]["avg(games)"]));
  };

  setAvgGamesAWeek = (v) => {
    this.avgGamesAWeek = v;
  };
  getAvgGamesAWeek = async (range) => {
    const [avgGamesAWeekErr, avgGamesAWeekRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getAvgGamesAWeek`, {
        params: range ? { start: range.start, end: range.end } : null,
      })
    );
    if (avgGamesAWeekErr) {
      console.log("get average games a week Error: ", avgGamesAWeekErr);
      return;
    }
    this.setAvgGamesAWeek(Math.round(avgGamesAWeekRes.data[0]["avg(games)"]));
  };

  setAvgGamesAMonth = (v) => {
    this.avgGamesAMonth = v;
  };
  getAvgGamesAMonth = async (range) => {
    const [avgGamesAMonthErr, avgGamesAMonthRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getAvgGamesAMonth`, {
        params: range ? { start: range.start, end: range.end } : null,
      })
    );
    if (avgGamesAMonthErr) {
      console.log("get average games a month Error: ", avgGamesAMonthErr);
      return;
    }
    this.setAvgGamesAMonth(Math.round(avgGamesAMonthRes.data[0]["avg(games)"]));
  };

  setFailedAttempts = (v) => {
    this.failedAttempts = v;
  };
  getFailedAttempts = async (range) => {
    const [failedAttemptsErr, failedAttemptsRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getFailedAttempts`, {
        params: range ? { start: range.start, end: range.end } : null,
      })
    );
    if (failedAttemptsErr) {
      console.log("get failed attempts Error: ", failedAttemptsErr);
      return;
    }
    this.setFailedAttempts(Math.round(failedAttemptsRes.data[0]["count(*)"]));
  };

  setReplayInstruction = (v) => {
    this.replayInstruction = v;
  };
  getReplayInstruction = async (range) => {
    const [replayInstructionErr, replayInstructionRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getReplayInstruction`, {
        params: range ? { start: range.start, end: range.end } : null,
      })
    );
    if (replayInstructionErr) {
      console.log("get replay instruction Error: ", replayInstructionErr);
      return;
    }
    this.setReplayInstruction(
      Math.round(replayInstructionRes.data[0]["count(*)"])
    );
  };

  setHearAnswers = (v) => {
    this.hearAnswers = v;
  };
  getHearAnswers = async (range) => {
    const [hearAnswersErr, hearAnswersRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getHearAnswers`, {
        params: range ? { start: range.start, end: range.end } : null,
      })
    );
    if (hearAnswersErr) {
      console.log("get hear answers Error: ", hearAnswersErr);
      return;
    }
    this.setHearAnswers(Math.round(hearAnswersRes.data[0]["count(*)"]));
  };

  setFailedAttemptsToChild = (v) => {
    this.failedAttemptsToChild = v;
  };
  getFailedAttemptsToChild = async (range, idChild) => {
    const [failedAttemptsToChildErr, failedAttemptsToChildRes] =
      await AsyncTools.to(
        Axios.get(`/api/fact/getFailedAttemptsToChild`, {
          params: range
            ? { start: range.start, end: range.end, name: idChild }
            : { name: idChild },
        })
      );
    if (failedAttemptsToChildErr) {
      console.log(
        "get failed attempts to child Error: ",
        failedAttemptsToChildErr
      );
      return;
    }
    this.setFailedAttemptsToChild(
      Math.round(failedAttemptsToChildRes.data[0]["count(*)"])
    );
  };

  setReplayInstructionToChild = (v) => {
    this.replayInstructionToChild = v;
  };
  getReplayInstructionToChild = async (range, idChild) => {
    const [replayInstructionToChildErr, replayInstructionToChildRes] =
      await AsyncTools.to(
        Axios.get(`/api/fact/getReplayInstructionToChild`, {
          params: range
            ? { start: range.start, end: range.end, name: idChild }
            : { name: idChild },
        })
      );
    if (replayInstructionToChildErr) {
      console.log(
        "get replay instruction Error: ",
        replayInstructionToChildErr
      );
      return;
    }
    this.setReplayInstructionToChild(
      Math.round(replayInstructionToChildRes.data[0]["count(*)"])
    );
  };

  setHearAnswersToChild = (v) => {
    this.hearAnswersToChild = v;
  };
  getHearAnswersToChild = async (range, idChild) => {
    const [hearAnswersToChildErr, hearAnswersToChildRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getHearAnswersToChild`, {
        params: range
          ? { start: range.start, end: range.end, name: idChild }
          : { name: idChild },
      })
    );
    if (hearAnswersToChildErr) {
      console.log("get hear answers Error: ", hearAnswersToChildErr);
      return;
    }
    this.setHearAnswersToChild(
      Math.round(hearAnswersToChildRes.data[0]["count(*)"])
    );
  };

  getDataForGameCake = async (range) => {
    const [countError, countRes] = await AsyncTools.to(
      Axios.get(`/api/fact/countGames`, {
        params: range ? { start: range.start, end: range.end } : null,
      })
    );
    if (countError) {
      console.log("count games Error: ", countError);
      return;
    }
    this.setCakeData({ all: countRes.data.all, done: countRes.data.done });
  };
  setCakeData = (v) => {
    this.cakeData = v;
  };
  getDataForListTable = async (limit, skip, range) => {
    const [countError, countRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getGamesInfo`, {
        params: {
          limit: limit,
          skip: skip,
          start: range && range.start,
          end: range && range.end,
        },
      })
    );
    if (countError) {
      console.log("getGamesInfo Error: ", countError);
      return;
    }
    let list = countRes.data.map((item) => {
      let d = new Date(item.ts);
      return {
        day: d.getDate() + "." + (Number(d.getMonth()) + 1),
        hour: d.getHours() + ":" + d.getMinutes(),
        players: item.student,
        lowLanguage: item.low_lang_level,
        highLanguage: item.high_lang_level,
        lowMath: item.low_math_level,
        midMath: item.medium_math_level,
        highMath: item.high_math_level,
      };
    });
    if (limit === 6) {
      this.setTableListData(list);
    } else {
      if (skip > 0) {
        this.setTableListDataFull([...this.tableListDataFull, ...list]);
      } else {
        this.setTableListDataFull(list);
      }
    }
    // return countRes?.data.length;
  };
  setTableListDataFull = (v) => {
    this.tableListDataFull = v;
  };
  setTableListData = (v) => {
    this.tableListData = v;
  };
  getDataForHearDonut = async (range) => {
    const [countError, countRes] = await AsyncTools.to(
      Axios.get(`/api/fact/countRelistens`, {
        params: range ? { start: range.start, end: range.end } : null,
      })
    );
    if (countError) {
      console.log("countRelistens Error: ", countError);
      return;
    }

    let percent1 = Math.round(countRes.data.events[0].rereadind_event * 100);
    let percent2 = Math.round(countRes.data.answers[0].reading_answer * 100);
    let data1 = [
      { value: 100 - percent1, color: colors.lightGrey },
      { value: percent1, color: colors.blue },
    ];
    this.setHearDonut1(data1);
    let data2 = [
      { value: 100 - percent2, color: colors.lightGrey },
      { value: percent2, color: colors.blue },
    ];
    this.setHearDonut2(data2);
  };
  setHearDonut1 = (v) => {
    this.hearDonutData1 = v;
  };
  setHearDonut2 = (v) => {
    this.hearDonutData2 = v;
  };
  getDataForDistributionLang = async () => {
    const [countError, countRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getDistributionsLang`)
    );
    if (countError) {
      console.log("getDistributionsLang Error: ", countError);
      return;
    }
    let langDist = countRes.data.language;
    let lowLang = 0;
    let highLang = 0;
    let allStudents = 0;
    for (let i = 0; i < langDist.length; i++) {
      if (langDist[i].language_level === "1") {
        lowLang = Number(langDist[i].student);
      }
      if (langDist[i].language_level === "2") {
        highLang = Number(langDist[i].student);
      }
      allStudents += Number(langDist[i].student);
    }

    const level1 = {
      insideText: "מהילדים",
      bottomTitle: "רמה נמוכה",
      data: [
        { color: colors.lanLowDark, key: "נמוכה", val: lowLang },
        { color: colors.lanHighLight, key: "גבוהה", val: highLang },
      ],
      percent: Math.round((lowLang / allStudents) * 100) + "%",
    };
    this.setLangLevel1(level1);
    const level2 = {
      insideText: "מהילדים",
      bottomTitle: "רמה גבוהה",
      data: [
        { color: colors.lanLowLight, key: "נמוכה", val: lowLang },
        { color: colors.lanHighDark, key: "גבוהה", val: highLang },
      ],
      percent: Math.round((highLang / allStudents) * 100) + "%",
    };
    this.setLangLevel2(level2);
  };
  setLangLevel1 = (v) => {
    this.langLevel1 = v;
  };
  setLangLevel2 = (v) => {
    this.langLevel2 = v;
  };
  getDataForDistributionMath = async () => {
    const [countError, countRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getDistributionsMath`)
    );
    if (countError) {
      console.log("getDistributionsMath Error: ", countError);
      return;
    }
    let mathDist = countRes.data.math;
    let lowMath = 0;
    let midMath = 0;
    let highMath = 0;
    let allStudents = 0;
    for (let i = 0; i < mathDist.length; i++) {
      if (mathDist[i].math_level === "1") {
        lowMath = Number(mathDist[i].student);
      }
      if (mathDist[i].math_level === "2") {
        midMath = Number(mathDist[i].student);
      }
      if (mathDist[i].math_level === "3") {
        highMath = Number(mathDist[i].student);
      }
      allStudents += Number(mathDist[i].student);
    }

    const mathl1 = {
      insideText: "מהילדים",
      bottomTitle: "רמה נמוכה",
      data: [
        { color: colors.mathLowDark, key: "נמוכה", val: lowMath },
        { color: colors.mathMidLight, key: "בינונית", val: midMath },
        { color: colors.mathHighLight, key: "גבוהה", val: highMath },
      ],
      percent: Math.round((lowMath / allStudents) * 100) + "%",
    };
    this.setMathLevel1(mathl1);
    const mathl2 = {
      insideText: "מהילדים",
      bottomTitle: "רמה בינונית",
      data: [
        { color: colors.mathLowLight, key: "נמוכה", val: lowMath },
        { color: colors.mathMidDark, key: "בינונית", val: midMath },
        { color: colors.mathHighLight, key: "גבוהה", val: highMath },
      ],
      percent: Math.round((midMath / allStudents) * 100) + "%",
    };
    this.setMathLevel2(mathl2);
    const mathl3 = {
      insideText: "מהילדים",
      bottomTitle: "רמה גבוהה",
      data: [
        { color: colors.mathLowLight, key: "נמוכה", val: lowMath },
        { color: colors.mathMidLight, key: "בינונית", val: midMath },
        { color: colors.mathHighDark, key: "גבוהה", val: highMath },
      ],
      percent: Math.round((highMath / allStudents) * 100) + "%",
    };
    this.setMathLevel3(mathl3);
  };
  setMathLevel1 = (v) => {
    this.mathLevel1 = v;
  };
  setMathLevel2 = (v) => {
    this.mathLevel2 = v;
  };
  setMathLevel3 = (v) => {
    this.mathLevel3 = v;
  };
  setAllTimeBoardGame = (v) => {
    this.allTimeBoardgame = v;
  };
  setTopTimeBoardgame = (v) => {
    this.topTimeBoardgame = v;
  };

  getAllTimeBoardgame = async (limit, skip, range) => {
    const [allTimeErr, allTimeRes] = await AsyncTools.to(
      Axios.get(`/api/fact/getAllTimeBoardgame`, {
        params: {
          limit: limit,
          skip: skip,
          start: range && range.start,
          end: range && range.end,
        },
      })
    );
    if (allTimeErr) {
      console.log("getAllTimeBoardgame Error: ", allTimeErr);
      return;
    }
    let list = allTimeRes.data.time.map((item) => {
      // console.log("item: ", item);
      return {
        boardName: item.board,
        avgTimeBoard: item.time,
      };
    });
    if (limit === 4) {
      this.setTopTimeBoardgame(list);
    } else {
      if (skip > 0) {
        this.setAllTimeBoardGame([...this.allTimeBoardgame, ...list]);
      } else {
        this.setAllTimeBoardGame(list);
      }
    }
    // return allTimeRes?.data.length;
  };
}

const data = new Data();

export const [DataContext, DataProvider, useData] = createMobXContext(data);



// WEBPACK FOOTER //
// ./src/stores/Data.store.js